import { useTranslation } from 'react-i18next';
import { ComponentProps } from 'react';

import { DeleteButton } from './DeleteButton';

interface ApiDeleteButtonProps extends ComponentProps<typeof DeleteButton> {
  hasWritePermission: boolean;
}

export const ApiDeleteButton = ({
  hasWritePermission,
  ...deleteButtonProps
}: ApiDeleteButtonProps) => {
  const { t } = useTranslation();

  return (
    <DeleteButton
      disabled={!hasWritePermission}
      {...(!hasWritePermission && { tooltip: t('Requires write permissions') })}
      {...deleteButtonProps}
    />
  );
};
